import { render, staticRenderFns } from "./TicketRequest.vue?vue&type=template&id=f95b2bca&scoped=true&"
import script from "./TicketRequest.vue?vue&type=script&lang=ts&"
export * from "./TicketRequest.vue?vue&type=script&lang=ts&"
import style0 from "./TicketRequest.vue?vue&type=style&index=0&id=f95b2bca&lang=sass&scoped=true&"
import style1 from "./TicketRequest.vue?vue&type=style&index=1&id=f95b2bca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b2bca",
  null
  
)

export default component.exports